import * as React from 'react';
import { connect } from 'react-redux';
import AllErasingButtons from './AllErasingButtons';
import CurrentToolIcon from '../header-toolbar/CurrentToolIcon';
import { Dispatch, Action } from 'redux';
import NewToolbarItemScroller from '../common/toolbar-item-scroller/NewToolbarItemScroller';
import IconButton from '../common/IconButton';
import { IntegratedDrawingState } from '../../reducers/integratedDrawing';
import { AppStates } from '../../../../..';

interface HeaderToolbarAllErasingLevelProps {
  readonly isVertical: boolean;
  readonly popLevel: () => void;
  readonly popToTopLevel: () => void;
  readonly dispatch: Dispatch<Action>;
  readonly integratedDrawing: IntegratedDrawingState;
}

const HeaderToolbarAllErasingLevel: React.SFC<
  HeaderToolbarAllErasingLevelProps
> = React.memo((props) => {
  const { isVertical, popLevel, popToTopLevel } = props;

  return (
    <>
      <CurrentToolIcon />

      <NewToolbarItemScroller vertical={isVertical} alignEnd={false} scrollButtons={true}>
        <AllErasingButtons {...props} />
      </NewToolbarItemScroller>

      <IconButton
        title="戻る"
        imagePath="images/tool-icons/new/btn_return/btn_return"
        rouondRect={true}
        onClick={popLevel}/>
      <IconButton
        title="トップ"
        imagePath="images/tool-icons/new/btn_top/btn_top"
        rouondRect={true}
        onClick={popToTopLevel} />
    </>
  );
});

const mapStateToProps = (appStates: AppStates) => (
  { integratedDrawing: appStates.integratedDrawing }
);

export default connect(mapStateToProps)(HeaderToolbarAllErasingLevel);
